import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { createAbsoluteUrl } from "utils/constants";
import { useGlobalSlice } from "app/slice";
import { RootState } from "types";
import { UpgradeSecurityPlan } from "./upgrade-security-plan";

import { Label } from "app/components/ui/label";
import { Button } from "app/components/ui/button";
import { Icons } from "app/components/ui/icons";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectGroup,
  SelectItem,
} from "app/components/ui/select";

interface Props {
  verifyData: any;
  verifyLoading: boolean;
}

const planOptions = (plan: number) => {
  return [
    { value: 1, label: "Complete Individual +$10/month" },
    { value: 2, label: "Complete Family +$20/month" },
  ];
};

export const VleMobileAccount = ({ verifyData, verifyLoading }: Props) => {
  const [isUpgradePlan, setIsUpgradePlan] = useState(false);
  const [plan, setPlan] = useState(1);
  const [addPlanSelect, setAddPlanSelect] = useState(false);
  const [hasPlanSelected, setHasPlanSelected] = useState(false);
  const dispatch = useDispatch();
  const { actions, useLazyGetDigitalSecurityCurrentAndUpgradePlansQuery } =
    useGlobalSlice();
  const navigate = useNavigate();
  const user = useSelector((state: RootState) => state.global?.user);

  // Digital Security Plans Query
  const [
    getDigitalSecurityPlans,
    {
      data: digitalSecurityData,
      isLoading: digitalSecurityLoading,
      isSuccess: digitalSecuritySuccess,
      isError: digitalSecurityError,
      error: digitalSecurityErrorData,
    },
  ] = useLazyGetDigitalSecurityCurrentAndUpgradePlansQuery();

  // Fetch digital security plans when component mounts
  useEffect(() => {
    if (user?._id) {
      getDigitalSecurityPlans({ customerId: user._id });
    }
  }, [user?._id, getDigitalSecurityPlans]);

  // Log digital security data when it changes
  useEffect(() => {
    if (digitalSecuritySuccess && digitalSecurityData) {
      console.log(
        "VLE Mobile Account - Digital Security Data:",
        digitalSecurityData
      );
      // Store in global state
      dispatch(
        actions.setDigitalSecurityCurrentAndUpgradePlans(digitalSecurityData)
      );
    }
    if (digitalSecurityError) {
      console.error(
        "VLE Mobile Account - Digital Security Error:",
        digitalSecurityErrorData
      );
    }
  }, [
    digitalSecuritySuccess,
    digitalSecurityData,
    digitalSecurityError,
    digitalSecurityErrorData,
    dispatch,
    actions,
  ]);

  return (
    <React.Fragment>
      <div className="">
        <div className="">
          <h4 className="mb-4 text-xl font-bold leading-5 text-black sm:text-[1.35rem] lg:text-2xl sm:leading-6 lg:leading-7 font-mobile sm:mb-6 lg:mb-9">
            VLE Mobile Account
          </h4>
          <div className="space-y-4 sm:space-y-[1.125rem]">
            <div className="space-y-1.5 sm:space-y-2 md:space-y-2.5">
              <div className="flex justify-between items-center">
                <h4 className="text-[#1D1D1B] text-sm sm:text-[0.935rem] lg:text-base font-semibold leading-6">
                  Active Lines:
                </h4>
                <p className="text-[#1D1D1B] text-sm sm:text-[0.935rem] lg:text-base font-semibold leading-6">
                  {verifyData?.data?.Activeline || 1}/1
                </p>
              </div>
              <div className="bg-[#E5E7EB] w-full h-px"></div>
              <div className="flex justify-between items-center">
                <h4 className="text-[#1D1D1B] text-sm sm:text-[0.935rem] lg:text-base font-semibold leading-6">
                  Security Plan:
                </h4>
                <p className="text-[#1D1D1B] text-sm sm:text-[0.935rem] lg:text-base font-semibold leading-6">
                  {verifyData?.data?.securityPlan?.securityPlanName}
                </p>
              </div>
              {/* <UpgradeSecurityPlan /> */}
            </div>
            {/* {verifyData?.data?.Activeline >= 1 && (
              <div className="hidden sm:block bg-[#F5F5F5] p-3 sm:p-[0.875rem] rounded-xl">
                <p className="text-black text-[0.725rem] sm:text-xs font-medium leading-4 sm:leading-5 mb-1 sm:mb-[0.375rem]">
                  You have used all lines allowed for your account. Please
                  contact customer service for assistance.
                </p>
                <Link
                  to="/support-tickets/submit-ticket"
                  className="text-[0.7rem] sm:text-xs font-medium leading-4 sm:leading-5 text-[#FE4D01] underline decoration-solid decoration-skip-ink decoration-[auto] underline-offset-[auto] [text-underline-position:from-font]"
                >
                  Create Support Ticket
                </Link>
              </div>
            )} */}
          </div>
        </div>
        {/* {verifyData?.data?.Activeline >= 1 && (
          <div className="sm:hidden bg-[#F5F5F5] p-3 rounded-xl mb-[1.125rem]">
            <p className="text-black text-[0.725rem] font-medium leading-4 mb-1">
              You have used all lines allowed for your account. Please
              contact customer service for assistance.
            </p>
            <Link
              to="/support-tickets/submit-ticket"
              className="text-[0.7rem] font-medium leading-4 text-[#FE4D01] underline decoration-solid decoration-skip-ink decoration-[auto] underline-offset-[auto] [text-underline-position:from-font]"
            >
              Create Support Ticket
            </Link>
          </div>
        )} */}
      </div>
      {/* {verifyData?.data?.Activeline === 0 && (
        <Button
          type="button"
          variant="primary"
          onClick={() => navigate("/single-network-phone-type")}
          disabled={verifyLoading || verifyData?.data?.Activeline === 1}
        >
          {verifyLoading ? (
            <div className="flex items-center gap-0.5 sm:gap-1">
              <Icons.Spinner className="animate-spin size-4 md:size-5" />
              <span>Verifying...</span>
            </div>
          ) : (
            "Continue"
          )}
        </Button>
      )} */}
    </React.Fragment>
  );
};
